import { Expose /*Type*/ } from "class-transformer";
import { IsNumber /*ValidateNested*/ } from "class-validator";

export class GenericTableResponse<T> {
  @IsNumber()
  @Expose()
  totalCount!: number;
  //@Type(()=>)
  //@ValidateNested()
  @Expose()
  items!: Array<T>;
}

export default GenericTableResponse;
